<template>
  <div class="panel">
    <!-- Lightbox player -->
    <transition name="menu-popover">
      <div v-if="playing" class="lightbox" @click.self="closeLightbox">
        <h2 class="closeX" @click="closeLightbox">
          <a href="#" aria-label="Close video" @click.prevent style="color:#fff; text-decoration: none;">&#215;</a>
        </h2>
        <div class="lightbox-vid">
          <div class="video-frame">
            <iframe
              :src="playing.src"
              :title="playing.title"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </transition>

    <div class="panel-head">
      <h2 class="panel-title">Featured Videos</h2>
      <router-link :to="moreLink" class="panel-link">
        View more <span class="material-icons">arrow_forward</span>
      </router-link>
    </div>

    <div v-if="featured" class="panel-body">
      <!-- Featured -->
      <button type="button" class="poster" :aria-label="`Play ${featured.title}`" @click="play(featured)">
        <img :src="featured.poster" :alt="featured.title" />
        <span class="play-btn" aria-hidden="true">
          <span class="material-icons">play_arrow</span>
        </span>
      </button>

      <h3 class="vid-title">{{ featured.title }}</h3>
      <p class="vid-desc">{{ featured.desc }}</p>

      <!-- Up next -->
      <div class="up-next">
        <h4 class="up-next-label">Up next</h4>
        <div class="thumbs">
          <button
            v-for="v in upNext"
            :key="v.id"
            type="button"
            class="thumb"
            :title="v.title"
            @click="selectedIndex = videos.indexOf(v)"
          >
            <span class="thumb-img">
              <img :src="v.poster" alt="" loading="lazy" />
              <span class="material-icons thumb-play" aria-hidden="true">play_circle</span>
            </span>
            <span class="thumb-title">{{ v.title }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const WIDEN = "https://spacesaver.widen.net/view/video/";

export default {
  name: "FeaturedVideos",
  data() {
    return {
      moreLink: "/marketing-materials?cat=Products/&file=video",
      selectedIndex: 0, // newest video first
      playing: null,
      // Newest first. To add a video: paste its Widen "view/video/..." path, poster and description.
      videos: [
        {
          id: "cet-2026-10-01",
          title: "CET Workshop 10-01-26",
          src: WIDEN + "vl5ds35d2x/CET-Workshop----10-01-26--Updates--Discussion.mp4?u=b4bimj",
          poster: "/vid-cards/10-01-26-thumb.jpg",
          desc: "The meeting covered upcoming CET fixes and releases, including pick-list and elevation improvements, mobile and Bay Editor crash fixes, Sketch and Build for version 17.5, and troubleshooting for tagging, dimensions, platforms, and other workflow issues.",
        },
        {
          id: "A&D CEU Presentation Fundamentals",
          title: "A&D CEU Presentation Fundamentals",
          src: WIDEN + "1xve58jnys/Video-AD-CEU-Presentation-Fundamentals---Sales-Training-Course.mp4?u=b4bimj",
          poster: "/training-thumbnails/ceu-presentation-thumb.jpg",
          desc: "Build stronger relationships with architects and designers and deliver impactful CEU presentations with confidence in the A&D CEU Presentation Fundamentals Sales Training course. Learn how to effectively prepare, present, and follow up on accredited CEU programs, leverage available resources and best practices, engage audiences through meaningful conversations.",
        },
       
        {
          id: "LAER Bonding Process",
          title: "LAER Bonding Process",
          src: WIDEN + "5y36ykw7j5/Video-LAER-Bonding-Process---Sales-Training-Course.mp4?u=b4bimj",
          poster: "/training-thumbnails/laer-thumb.jpg",
          desc: "Build stronger customer relationships and handle objections with confidence in the LAER Bonding Process Sales Training course. Learn how to apply the Listen, Acknowledge, Explore, Respond (LAER) framework to better understand customer concerns, build rapport, uncover underlying challenges, and deliver thoughtful, value-focused responses that lead to stronger relationships and successful sales outcomes.",
        },
         
        {
          id: "Hospital Campus Targets",
          title: "Hospital Campus Targets",
          src: WIDEN + "qxd9b5p9rk/Video-Hospital-Campus-Targets---Key-Personnel---Sales-Training-Course.mp4?u=b4bimj",
          poster: "/training-thumbnails/key-personnel-thumb.jpg",
          desc: "Discover the Hospital Campus Targets: Key Personnel Sales Course to gain a deeper understanding of the key decision-makers and influencers across hospital departments. Learn how pharmacists, pharmacy technicians, emergency department leaders, nurse managers, surgical services directors, and other personnel impact purchasing decisions, workflow planning, patient care, compliance, and operational efficiency, helping you align Spacesaver solutions with the priorities that matter most to each stakeholder.",
        },
    
      ],
    };
  },
  computed: {
    featured() {
      return this.videos[this.selectedIndex] || null;
    },
    // The next three videos after the featured one (wraps around)
    upNext() {
      const n = this.videos.length;
      return [1, 2, 3]
        .filter(step => step < n)
        .map(step => this.videos[(this.selectedIndex + step) % n]);
    },
  },
  methods: {
    play(video) {
      this.playing = video;
    },
    closeLightbox() {
      this.playing = null;
    },
    onKeydown(e) {
      if (e.key === "Escape") this.closeLightbox();
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
  },
};
</script>

<style scoped>
.panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #eef0f2;
}
.panel-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e3040;
  margin: 0;
}
.panel-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
  white-space: nowrap;
}
.panel-link:hover {
  color: #1e3040;
  text-decoration: none;
}
.panel-link .material-icons {
  font-size: 18px;
  transition: transform 0.2s;
}
.panel-link:hover .material-icons {
  transform: translateX(3px);
}
.panel-body {
  padding: 20px;
}

/* Featured poster */
.poster {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  aspect-ratio: 16 / 9;
}
.poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, opacity 0.2s;
}
.poster:hover img {
  transform: scale(1.03);
  opacity: 0.9;
}
.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #429da8;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, background 0.2s;
}
.play-btn .material-icons {
  font-size: 44px;
}
.poster:hover .play-btn {
  transform: translate(-50%, -50%) scale(1.08);
  background: #fff;
}
.poster:focus-visible {
  outline: 3px solid #429da8;
  outline-offset: 2px;
}

.vid-title {
  font-size: 19px;
  font-weight: 500;
  color: #1e3040;
  margin: 16px 0 6px;
}
.vid-desc {
  color: #575757;
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Up next */
.up-next {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #eef0f2;
}
.up-next-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a96a3;
  margin: 0 0 10px;
}
.thumbs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.thumb {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}
.thumb-img {
  position: relative;
  display: block;
  aspect-ratio: 16 / 9;
  border-radius: 4px;
  overflow: hidden;
  background: #eceff1;
}
.thumb-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.2s;
}
.thumb-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 30px;
  opacity: 0;
  transition: opacity 0.2s;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}
.thumb:hover .thumb-img img {
  opacity: 0.8;
}
.thumb:hover .thumb-play {
  opacity: 1;
}
.thumb-title {
  font-size: 13px;
  line-height: 1.3;
  color: #4d5967;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.thumb:hover .thumb-title {
  color: #429da8;
}
.thumb:focus-visible {
  outline: 2px solid #429da8;
  outline-offset: 2px;
  border-radius: 4px;
}

/* Lightbox video */
.video-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
}
.video-frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 575px) {
  .thumbs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .thumbs .thumb:nth-child(3) {
    display: none;
  }
}
</style>
